import { Code } from "./code";
import React from "react";
import { Canvas } from "react-scribble";
import { Container } from "./container";
import { Box } from "./box";
import { Scribbles } from "./scribbles";
import { Background } from "./background";
import { useBoundingRect } from "./bounding-rect";
import { Header, Paragraph, Display, SubHeader } from "./fonts";
import { Circle } from "./circle";

const WIDTH = () => Math.min(window.innerWidth, 600);

const installScript = `npm install react-scribble --save
# or
yarn add react-scribble`;

const canvasScript = `import { Canvas } from 'react-scribble'

const MyCoolAppComponent = () => {
  return (
    <Canvas
      loop
      width={window.innerWidth}
      height={window.innerHeight}
    >
      {/* my projects components */}
    </Canvas>
  )
}`;

const hookScript = `import { useCallback } from 'react'
import { useDraw } from 'react-scribble'

const Circle = ({ x, y }) => {
  // TEMP: draw functions currently need something
  // to stop the reference to stop updating
  const drawCircle = useCallback(
    (ctx, canvas) => {
      ctx.fillStyle = 'tomato'
      ctx.beginPath()
      ctx.arc(x, y, 50, 0, Math.PI * 2, true)
      ctx.fill()
    },
    [x, y]
  )

  useDraw(drawCircle) // draws the circle

  return null // you can return dom element here too.
}`;

const allScript = `const MyCoolAppComponent = () => {
  return (
    <Canvas
      loop
      width={window.innerWidth}
      height={window.innerHeight}
    >
      <Circle x={100} y={100} />
      <Circle x={200} y={200} />
    </Canvas>
  )
}`;

const arr = new Array(100).fill(0).map((x, i) => i);

export const Instructions = ({ scroll }) => {
  const { ref } = useBoundingRect();
  const width = WIDTH();

  return (
    <Container width={width}>
      <Background
        width={width + 20}
        offset={30}
        scroll={scroll}
        color="#ffcc99"
      />
      <Background width={width} scroll={scroll} />
      <Box color="foreground" alignSelf="center">
        <Box
          Component="span"
          css={{ fontSize: "4em", margin: 0 }}
          role="img"
          aria-label="scribble emoji"
        >
          ✍️
        </Box>

        <Display paddingTop="s">React Scribble</Display>
        <Paragraph>
          React scribble is a react component that allows you to draw to canvas
          using hooks. This means that you can write individual component to
          draw a canvas in a declarative way.
        </Paragraph>
      </Box>
      <Box ref={ref}>
        <Code code={installScript} language="shell" />
      </Box>
      <Box>
        <Header>Usage</Header>
        <Paragraph>
          You will need to setup the canvas and then use hooks to access the
          draw function.
        </Paragraph>
        <SubHeader>Setting up a canvas</SubHeader>
        <Paragraph>
          Scribble outputs a component called Canvas. Render it and give it a
          height and width.
        </Paragraph>
        <Code code={canvasScript} language="jsx" />
        <SubHeader>Hooking into the draw</SubHeader>
        <Paragraph>
          The hook allows you to pass a function to the useDraw hook, and that
          hook will be called every time the canvas is drawn.
        </Paragraph>
        <Code code={hookScript} language="javascript" />
        <SubHeader>Composing all together</SubHeader>
        <Paragraph>
          Then add the components with the draw hook into the canvas. This
          should two circles to the canvas.
        </Paragraph>
        <Code code={allScript} language="jsx" />
        <SubHeader>Example</SubHeader>
        <Box paddingBottom="m" paddingTop="m">
          <Box css={{ backgroundColor: "#fff" }} borderRadius="m">
            <Canvas loop width={500} height={300}>
              <Circle x={100} y={100} radius={50} color="tomato" />
              <Circle x={200} y={200} radius={50} color="tomato" />
            </Canvas>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};
